import {BaseModel} from "../../../infrastructure/models/base-model";
import {SCHEMA_TYPE} from "./consts";

export class BaseSchemaDataModel extends BaseModel {
  type: SCHEMA_TYPE;
  name: String;
  url: String
}

export class BaseSchemaModel extends BaseSchemaDataModel {
  constructor(type: String, name: String, url: String) {
    super();

    this.type = type;
    this.name = name;
    this.url = url;
  }

  get contextParams(): String {
    return `"@context":"https://schema.org"`;
  }

  get typeParams(): String {
    return this.type ? `,"@type":"${this.type}"` : `` ;
  }

  get nameParams(): String {
    return this.name ? `,"name":${JSON.stringify(this.name)}` : `` ;
  }

  get urlParams(): String {
    return this.url ? `,"url": "${this.url}"` : '';
  }

  toString(): String {
    return `${this.contextParams}${this.typeParams}${this.nameParams}${this.urlParams}`
  }

  listItemToString(list, item, index): String {
    const comma: String = index !== 0 ? `,` : '';

    return comma + item.toString() ;
  }
}
